"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promptUseOnIHaier = exports.getFormatRes = exports.getMyRes = void 0;
var tslib_1 = require("tslib");
var chivy_1 = tslib_1.__importDefault(require("chivy"));
var c = new chivy_1.default("iHaier2.0 API 调用");
var isEmpty = function (obj) { return (Object.keys(obj).length === 1 ? true : false); };
function getMyRes(res) {
    var myRes = {};
    if (!isEmpty(res)) {
        myRes.data = {};
        Object.assign(myRes.data, res);
        delete myRes.data.errMsg;
    }
    myRes.success = true;
    return myRes;
}
exports.getMyRes = getMyRes;
function getFormatRes(apiName, options) {
    c.info("开始调用api " + apiName);
    return new Promise(function (resolve) {
        options.success = function (res) {
            var myRes = getMyRes(res);
            resolve(myRes);
        };
        options.fail = function (res) {
            res.success = false;
            resolve(res);
        };
        globalThis.h5sdk.ready(function () {
            globalThis.tt[apiName](options);
        });
    });
}
exports.getFormatRes = getFormatRes;
function promptUseOnIHaier() {
    return new Promise(function (resolve) {
        var myRes = {};
        myRes.errMsg = "请在iHaier客户端或者APP查看";
        resolve(myRes);
    });
}
exports.promptUseOnIHaier = promptUseOnIHaier;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Rm9ybWF0UmVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3V0aWwvZ2V0Rm9ybWF0UmVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSx3REFBMkI7QUFDM0IsSUFBTSxDQUFDLEdBQUcsSUFBSSxlQUFNLENBQUMsa0JBQWtCLENBQUMsQ0FBQztBQUN6QyxJQUFNLE9BQU8sR0FBRyxVQUFDLEdBQVEsSUFBYyxPQUFBLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxNQUFNLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxFQUE5QyxDQUE4QyxDQUFDO0FBRXRGLFNBQWdCLFFBQVEsQ0FBQyxHQUFRO0lBQy9CLElBQU0sS0FBSyxHQUFRLEVBQUUsQ0FBQztJQUV0QixJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUFFO1FBQ2pCLEtBQUssQ0FBQyxJQUFJLEdBQUcsRUFBRSxDQUFDO1FBQ2hCLE1BQU0sQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxHQUFHLENBQUMsQ0FBQztRQUMvQixPQUFPLEtBQUssQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO0tBQzFCO0lBQ0QsS0FBSyxDQUFDLE9BQU8sR0FBRyxJQUFJLENBQUM7SUFDckIsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDO0FBVkQsNEJBVUM7QUFDRCxTQUFnQixZQUFZLENBQUMsT0FBZSxFQUFFLE9BQVk7SUFDeEQsQ0FBQyxDQUFDLElBQUksQ0FBQyxVQUFVLEdBQUcsT0FBTyxDQUFDLENBQUM7SUFDN0IsT0FBTyxJQUFJLE9BQU8sQ0FBQyxVQUFBLE9BQU87UUFDeEIsT0FBTyxDQUFDLE9BQU8sR0FBRyxVQUFDLEdBQVE7WUFDekIsSUFBTSxLQUFLLEdBQUcsUUFBUSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1lBQzVCLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNqQixDQUFDLENBQUM7UUFDRixPQUFPLENBQUMsSUFBSSxHQUFHLFVBQUMsR0FBUTtZQUN0QixHQUFHLENBQUMsT0FBTyxHQUFHLEtBQUssQ0FBQztZQUNwQixPQUFPLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDZixDQUFDLENBQUM7UUFDRCxVQUFrQixDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUM7WUFDN0IsVUFBa0IsQ0FBQyxFQUFFLENBQUMsT0FBTyxDQUFDLENBQUMsT0FBTyxDQUFDLENBQUM7UUFDM0MsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDLENBQUMsQ0FBQztBQUNMLENBQUM7QUFmRCxvQ0FlQztBQUNELFNBQWdCLGlCQUFpQjtJQUMvQixPQUFPLElBQUksT0FBTyxDQUFDLFVBQUEsT0FBTztRQUN4QixJQUFNLEtBQUssR0FBUSxFQUFFLENBQUM7UUFDdEIsS0FBSyxDQUFDLE1BQU0sR0FBRyxvQkFBb0IsQ0FBQztRQUNwQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDakIsQ0FBQyxDQUFDLENBQUM7QUFDTCxDQUFDO0FBTkQsOENBTUMifQ==